<div id="emotion_cup">
  <div class="emotion_banner">

    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="banner_logo">
            <img class="img-responsive" src="assets/img/emotion/logo.svg" alt="" (click)="emotion_cup_route='default'">
          </div>
        </div>


        <div class="col-lg-7 col-lg-offset-1">
          <div class="header">
            <a href="http://emotiongaming.net" target="_blank" class="button">
              <i class="icon-globe"></i>
              {{language?.banner.Tournament_website}}
            </a>

            <!--<div class="button">-->
            <!--<i class="icon-phone"></i>-->
            <!--{{language?.Prizes_contacts.Contact_info}}-->
            <!--</div>-->

            <a href="https://facebook.com/emotiongaming1" target="_blank" class="button">
              <i class="icon-facebook-circled" style="font-size: 20px;"></i>
            </a>
            <div class="language_menu">
              <div class="go_button square sm" mat-icon-button [matMenuTriggerFor]="languageMenu">
                {{language?.Language}}
              </div>

              <mat-menu #languageMenu="matMenu">
                <button class="language_menu_options" value="en" mat-menu-item (click)="languageChange('en')">
                  <div class="flag en"></div>
                  <span>English</span>
                </button>
                <button class="language_menu_options" value="ar" mat-menu-item (click)="languageChange('ar')">
                  <div class="flag ar"></div>
                  <span>العربية</span>
                </button>
              </mat-menu>
            </div>
            <div class="go_button default square sm" (click)="eventService.shareEvent()" style="margin-left:10px"><i
              class="icon-facebook"></i>Share
            </div>
          </div>

          <h1>
            EMOTION GAMING CUP
          </h1>
          <p> 29 July - 14 September, 2018, Egypt</p>
          <div class="game_logo">
            <img width="150px" src="../../../../assets/img/games/fifa-18/logo.png" alt="">
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class=" container event_container">

    <mat-tab-group class="emotion_tabs">
      <mat-tab label="{{language?.banner.Tournaments_menu}}">

        <div [ngSwitch]="emotion_cup_route">
          <div *ngSwitchDefault>

            <div class="filter_header">
              <h1>{{language?.Tournaments.Choose_City}}</h1>
              <!--Sorting Button-->
              <div class="go_button city square right" mat-icon-button [matMenuTriggerFor]="filterCity">
                <i class="icon-globe"></i>
                <span style="text-transform: uppercase;"> {{language?.Choose_City}}</span>
              </div>
              <!--Sorting Menu-->
              <mat-menu #filterCity="matMenu" class="city-emotion-cup-menu">
                <button mat-menu-item (click)="filterByCity('Default')">
                  <span>{{language?.Tournaments.All_Tournaments}}</span>
                </button>
                <button mat-menu-item (click)="filterByCity('Cairo',language?.city.Cairo)">
                  <span>{{language?.city.Cairo}}</span>
                </button>
                <button mat-menu-item (click)="filterByCity('Giza',language?.city.Giza)">
                  <span>{{language?.city.Giza}}</span>
                </button>
                <button mat-menu-item (click)="filterByCity('Alexandria',language?.city.Alexandria)">
                  <span>{{language?.city.Alexandria}}</span>
                </button>
                <button mat-menu-item (click)="filterByCity('Mansoura',language?.city.Mansoura)">
                  <span>{{language?.city.Mansoura}}</span>
                </button>
                <button mat-menu-item (click)="filterByCity('Sharqia',language?.city.Sharqia)">
                  <span>{{language?.city.Sharqia}}</span>
                </button>
                <button mat-menu-item (click)="filterByCity('El-sahel',language?.city.El_sahel)">
                  <span>{{language?.city.El_sahel}}</span>
                </button>
              </mat-menu>
            </div>

            <div class="emotion-tournament-list-container"
                 *ngIf="!eventService.loadTournaments;else loadEventTournaments">
              <!--Tournaments list-->
              <div
                *ngFor="let tournament of (eventService.eventTournaments|async)?.data|dateSortTournament:true|searchPipe:game:'game'|searchPipe:city:'city'">
                <div class="row">
                  <div class="tournaments_container">
                    <div class="bar">
                      <div class="row">
                        <a target="_blank" class="col-sm-4 col-xs-12 zero_margin"
                           href="{{AppSettings.Href+'tournaments/'+tournament.code}}">
                          <div class="block start zero_margin">
                            <div class="row">
                              <img [src]="tournament.profile_picture"
                                   alt="Tournament Profile">
                              <h1>{{tournament.name |truncate:40}}</h1>
                            </div>
                          </div>
                        </a>

                        <div class="col-sm-8 col-xs-12 zero_margin">
                          <div class="flipper">
                            <div class="bar front">
                              <div class="row">


                                <div class="col-sm-4 col-xs-6 zero_margin">
                                  <div class="block">
                                    <p>
                                      <!--<i class="icon-location">-->
                                      <!--Geexpro, 6 October-->
                                      <!--</i>-->
                                    </p>
                                    <p (click)="PinnedLoc(tournament?.pinned_location)"
                                       *ngIf="(tournament?.pinned_location&&tournament?.pinned_location?.name  != '');else textLocation">
                                      <i class="icon-location " style="cursor: pointer">
                                        {{tournament?.location ? tournament?.location : tournament?.pinned_location?.name|truncate:20}}
                                      </i>
                                    </p>
                                    <ng-template #textLocation>
                                      <p *ngIf="tournament?.location">
                                        <i class="icon-globe">
                                          {{tournament?.location|truncate:20}}
                                        </i>
                                      </p>
                                    </ng-template>

                                  </div>
                                </div>


                                <a target="_blank" class="col-sm-4 col-xs-6 zero_margin"
                                   href="{{AppSettings.Href+'tournaments/'+tournament.code}}">
                                  <div class="block">
                                    <!--<p><i class="icon-calendar"></i><b>{{tournament.start_at}}</b></p>-->
                                    <p style="margin: 0">
                                      <i class="icon-hourglass"></i>
                                      <!--SUNDAY, 29-7-2018-->
                                      {{globalService.Date(tournament.start_at)}}

                                    </p>

                                    <p style="margin: 0">
                                      <i class="icon-clock"></i>
                                      {{globalService.Time(tournament.start_at)}}
                                    </p>
                                  </div>

                                  <div class="block">

                                  </div>
                                </a>

                                <a target="_blank" href="{{AppSettings.Href+'tournaments/'+tournament.code}}"
                                   class="zero_margin col-sm-4 col-xs-12">

                                  <div class="block">
                                    <div class="status"
                                         *ngIf="tournament.status == 'Waiting Players to Join'">
                                      <div class="icon active"></div>
                                      <p>
                                        {{language?.Tournaments.Waiting_players_to_join}}</p>
                                    </div>
                                    <div class="status" *ngIf="tournament.status == 'Finished'">
                                      <div class="icon finished"></div>
                                      <p>
                                        {{language?.Tournaments.Finished}}</p>
                                    </div>
                                    <div class="status"
                                         *ngIf="tournament.status == 'Registration Closed'">
                                      <div class="icon postponed"></div>
                                      <p>{{language?.Tournaments.Registration_Closed}}</p>
                                    </div>
                                    <div class="status"
                                         *ngIf="tournament.status == 'In Progress'">
                                      <div class="icon inprogress"></div>
                                      <p>
                                        {{language?.Tournaments.In_Progress}}</p>
                                    </div>
                                  </div>
                                </a>

                              </div>
                            </div>

                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>

              </div>

              <div
                *ngIf="((eventService.eventTournaments|async)?.data|searchPipe:game:'game'|searchPipe:city:'city')?.length==0"
                class="big_block points">
                <div class="content text-center">
                  <p>{{language?.Tournaments.No_Tournaments}}</p>
                </div>
              </div>
            </div>
            <ng-template #loadEventTournaments>
              <app-loading-indicator></app-loading-indicator>
            </ng-template>

          </div>
        </div>

      </mat-tab>

      <!--Rulse And Requlations-->
      <mat-tab label="{{language?.banner.Rules}}">
        <div class="emotion-rules">
          <div class="col-md-4">
          <pre>
            <h1>Game Settings</h1>
            • Game Tactics: Custom tactics allowed
            • Injuries: Off
            • Camera Settings: Tele Broadcast
            • Half Length: 5 minutes
            • Handball: Off
            • Time/Score display: On
            • HUD: Player Name Bar and Indicator On
            • Difficulty: Legendary
            • Game speed: Normal
            • Offside: On
            • Defense Type : Legacy or Tactical
          </pre>
          </div>
          <div class="col-md-8">
          <pre>
          <h1>Tournament Rules:</h1>
        • Controllers are supplied. It is the responsibility of all Players to be familiar with the controller’s functions and mode of operation.
        • If a controller is defective, a Player can pause the game and notify the referee once only, if the player agrees the problem is fixed he may not pause again.
        • You can bring your own controllers. No memory cards or saved games are permitted.
        • You cannot select any fictional or All-Star teams. Any regular season teams, as installed with the original game, can be selected. Both Players can select the same team.
        • You cannot select any fictional or All-Star teams. Any regular season teams, as installed with the original game, can be selected. Both Players can select the same team.

        <h1>General Rules:</h1>
        • All competitors are required to stay within the tournament area or inform the organizers in the event of stepping out.
        • All players are required to show up at least half an hour before the tournament.
        • Players not present at the designated start time for any match will be disqualified, and their opponent shall be considered as the winner.
        • Players not present at the designated start time for any match will be disqualified, and their opponent shall be considered as the winner.
        • Players not present at the designated start time for any match will be disqualified, and their opponent shall be considered as the winner.
        • In case of any kind of unfortunate event or disconnection, disc error or electricity failure, the score will remain the same regardless of game played but the half in which the problem occurred will be played again.
        • Any participant deliberately attempting to sabotage or damage equipment to restart matches will be immediately disqualified from the tournament.
        • Any persons who attempt to disrupt matches with verbal or physical abuse to referee/admin or competitors will be disqualified from the tournament and may be removed from the venue.
        • Refusal to play a match or committing any disruptive behavior that can delay the tournament will result in forfeit of the match regardless of contestant tournament standings.
        • Referees will be on site to monitor all game play. Referees will begin play, and will record scores for each game. Referees will be identified by a special ID tag.
        • In case of any other dispute, referee/admin’s decision will be final
        • The tournament rules may be subject to change at short notice on the spot</pre>

          </div>

        </div>
      </mat-tab>

      <!--Contacts section-->
      <mat-tab label="{{language?.Prizes_contacts.Prizes_Contacts}}">
        <div class="emotion-rules">
          <div class="col-md-4">
            <pre>
              <h1>{{language?.Prizes_contacts.Contact_info}}</h1>
              {{language?.Prizes_contacts.More_info}}
              <i class="icon-phone"></i> 01033433484
              <i class="icon-phone"></i> 01095595966
              <i class="icon-facebook"></i> <a href="https://Facebook.com/emotiongaming1" target="_blank">Facebook.com/emotiongaming1</a>
              <i class="icon-globe"></i> <a href="http://emtiongaming.net" target="_blank">Emotiongaming.net</a>

            </pre>
          </div>
          <div class="col-md-8" style="direction: rtl">
            <pre>
              <h1>{{language?.Prizes_contacts.Prizes}}</h1>
             • دلوقتي بطولة ايموشن علي مستوي مصر كلها و الجوائز اكتر من 200 جائزة قيمة
 • الاشتراك فى البطولة 250 جنيه و بعدها بتقدر تختار المكان اللي هتشارك فيه في البطولة و اللي هتكون بطولة فيها 32 مشترك
• جوائز البطولة الاولي

الاول 1500 جنيه + التأهل للبطولة الكبرى
الثاني 1000 جنيه + التأهل للبطولة الكبرى
الثالث 500 جنيه + التأهل للبطولة الكبرى
              الرابع التأهل للبطولة الكبرى

              جوائز  البطولة الكبري
الاول 30000 جنيه
الثاني 20000 جنيه
الثالث 10000 جنيه

• بمجرد اشتراكك هتقدر تتابع البطولة الخاصة بيك علي الموقع الخاص بتنظيم البطولة
 • البطولة هتكون علي مستوي 6 مدن في مصر

1-القاهرة
2-الجيزة
3-الساحل الشمالي
4-الاسكندرية
5-الشرقية
6-المنصورة

البطولة هتكون FIFA18 PS4

            </pre>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="{{language?.how_to_pay.how_to_pay}}">
        <div class="emotion-rules">
          <div class="col-md-12" style="direction: rtl">
          <pre>


          لازم تلحق تدفع و تكون جاهز تختار المكان الخاص بيك و ده لان الاماكن هتكون بتنزل يوميا و الاعداد فى كل مكان محدودة جدا و هيتم غلق التسجيل بمجرد نفاذ العدد و بمجرد ما هتدفع و تبعت الايصال هيجيلك الكود و اللينك اللي  تقدر من خلاله تختار المكان و المعاد الخاص بيك فى البطولة
          سعر الاشتراك 250 جنيه
          طرق الدفع
          1-تحويل فودافون كاش علي :
          01033433484
          01095595966
          و ارسال ايصال التحويل الي اي من ارقامنا او صفحة الفيسبوك

          2-تحويل اورانج كاش علي
          01206584996
          و ارسال ايصال التحويل الي اي من ارقامنا او صفحة الفيسبوك

          3-التحويل عن طريق فروع Super Fawry علي رقم ماكينة
          1469424
          و ارسال ايصال التحويل الي اي من ارقامنا او صفحة الفيسبوك


          4-هيكون متاح التسجيل او شراء التذاكر فى كل البلايستيشن المشاركة فى البطولة و هيتم ارسال اي اماكن متاحة للتسجيل فور توفر التفاصيل الخاصة بها

          </pre>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

  </div>


  <!--Sponsors-->

  <div class="container">
    <div class="row" style="text-align: center;">
      <div class="spacer md"></div>
      <div class="mid_title">
        <h1>{{language?.sponsors_organizers}}</h1>
      </div>

      <div class="emotion_banner_sponsors hidden-xs hidden-sm">
        <img width="150" src="assets/img/emotion/emotion-logo.png" alt="">
        <img width="100" src="assets/img/emotion/mybc-logo.png" alt="">
        <img width="100" src="assets/img/emotion/onsport-logo.png" alt="">
        <img width="150" src="assets/img/emotion/ahram-logo.png" alt="">
        <img width="150" src="assets/img/emotion/marseillia-logo.png" alt="">
      </div>

      <marquee class="emotion_banner_sponsors hidden-md hidden-lg" onmouseover="this.stop();"
               onmouseout="this.start();">
        <img width="120" src="assets/img/emotion/emotion-logo.png" alt="">
        <img width="100" src="assets/img/emotion/mybc-logo.png" alt="">
        <img width="100" src="assets/img/emotion/onsport-logo.png" alt="">
        <img width="120" src="assets/img/emotion/ahram-logo.png" alt="">
        <img width="120" src="assets/img/emotion/marseillia-logo.png" alt="">
      </marquee>


      <a href="http://emotiongaming.net/index.php/become-a-sponsor/" target="_blank" class="go_button square sm green"
         style="margin-top:50px !important;
      font-family: proxima_nova_rgregular; font-size: 14px; min-height: 60px; min-width:200px;">
        <i class="icon-handshake-o" style="margin:0 15px 0 0 ;"></i>
        {{language?.Become_sponsor}}
      </a>
    </div>
  </div>


  <!--&lt;!&ndash;Brackets&ndash;&gt;-->
  <!--<div class="container">-->
  <!--<div class="row">-->
  <!--<div class="emotion_brackets" [innerHTML]="eventService.Event.value.iframe_url|safeHtml">-->
  <!--</div>-->

  <!--</div>-->
  <!--</div>-->

  <!--Qualified Players-->

  <div class="container">
    <div class="row">
      <div class="spacer md"></div>
      <div class="mid_title">
        <h1>{{language?.Qualified_Players}}</h1>
        <p style="color:#333;">All qualified players will appear in this section</p>
      </div>

      <div class="qualified_players_container"
           *ngIf="eventService.qualified_Players?.length!=0;else No_qualified_players">
        <div *ngFor="let player of eventService.qualified_Players">
          <a class="players" target="_blank" href="./gamer/{{player.participant_name}}">
            <img src="{{player.avatar}}" alt="">
            <h1>{{player.participant_name}}</h1>
          </a>
        </div>
      </div>
      <ng-template #No_qualified_players>
        <div class="big_block">
          <div class="content text-center">
            <p>No qualified players yet.</p>
          </div>
        </div>
      </ng-template>
    </div>
  </div>


</div>


<!--footer-->
<div class="emotion_footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/logo-gray.svg" alt=""></a>

  <p>This tournament is organized by Emotion Gaming, hosted and powered by GBarena. For hosting a tournament on GBarena
    please visit
    <a href="https://www.gbarena.com" target="_blank">www.gbarena.com</a>
    <!--for more information about the tournament please contact 01033433484 - 01095595966 or visit our facebook page -->
    <!--<a href="https://Facebook.com/emotiongaming1" style="color:dimgray"><i class="icon-facebook"></i></a>-->
    <!--<br> for hosting a tournament on GBarena please visit www.gbarena.com-->
  </p>

</div>


<!--limiting fb chat to emotion facebook page-->

<div class="fb-customerchat"
     page_id="1756467031117920"
     theme_color="#9cb43b">
</div>
